export const environment = {
    production: true,
    debug     : true,
    api       : {
        graphql: 'https://hip-ama-aurora-back-production.azurewebsites.net/graphql',
        rest   : 'https://hip-ama-aurora-back-production.azurewebsites.net/',
    },
    lang: {
        base    : 'es',
        fallback: 'es',
        langs   : ['es','en'],
    },
    oAuth: {
        applicationCode  : 'aurora',
        applicationSecret: '$2y$10$EOA/SKEwKRgHPw64kO4LZ.6oy5b8kl6JzW/mCROMfSq6S38/IiywG',
    },
    appearance: {
        theme : 'theme-default',
        layout: 'classy',
    },
    msEntraId: {
        tenant: 'b6fbec92-ea74-4b61-a8a5-0ca5e669dca2',
        authority: 'https://login.microsoftonline.com/b6fbec92-ea74-4b61-a8a5-0ca5e669dca2',
        clientId: '0ca96ca1-6de1-48e0-b1a8-d55469876920',
        redirectUri: 'https://ama.hipartnerscloud.com/',
        scopes: ['api://b5adcb83-567f-4937-b42e-3094c1e1df5f/access_as_user'],
    }
};
